var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#0CA7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8889 26V21.7143C26.8889 20.8214 26.581 20.0625 25.9653 19.4375C25.3495 18.8125 24.6019 18.5 23.7222 18.5H14.0375L17.8375 22.3571L16.3333 23.8571L10 17.4286L16.3333 11L17.8375 12.5L14.0375 16.3571H23.7222C25.1824 16.3571 26.4271 16.8795 27.4563 17.9241C28.4854 18.9688 29 20.2321 29 21.7143V26H26.8889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseIcon);
export default __webpack_public_path__ + "static/media/response-icon.8250d3bb8f6d869e5c2cb3845f81ce5d.svg";
export { ForwardRef as ReactComponent };